<fgb-mobile-page-header [pageTitle]="'marketplace.page.title'" backButtonLink="/" />
<fgb-banner class="d-lg-block d-none" [title]="'marketplace.page.title' | translate" />

<div class="container mobile-container">
  <fgb-mixed-loyalty-nav></fgb-mixed-loyalty-nav>
  <div class="mt-3">
    <fgbcl-marketplace-list
      [isList]="true"
      [showSortBar]="false"
      [marketplaceItemTypes]="[0, 1, 2]"
      [defaultSort]="2"
    ></fgbcl-marketplace-list>
  </div>
</div>
